import '../plugins/characters-limit'

$.fn.CheckoutForm = function() {
  let self = this

  if (self.data('checkout-form') != undefined) {
    return self.data('checkout-form')
  }

  if (self.find('input[name="createaccount"]').length) {
    if (self.find('#shipping_city').val() != '') {
      self.find('#billing_city').val(self.find('#shipping_city').val())
    }
    if (self.find('#shipping_postcode').val() != '') {
      self.find('#billing_postcode').val(self.find('#shipping_postcode').val())
      self.find('#billing_state').val(self.find('#shipping_state').val()).trigger('change')
    }
  }

  if (self.find('#billing_country').length) {
    function countryNotice() {
      if (self.find('#billing_country').val() == 'CA') {
        $('.billing-country-notice').fadeOut(150, function() {
          $('.billing-country-notice').remove()
        })
      } else {
        let country_notice = $('<div></div>').addClass('billing-country-notice').html(gourmetsauvage_params.shipping_us)
        $('#billing_country_field').append(country_notice)
        $('input[name="ship_to_different_address"]').prop('checked', true).trigger('change')
      }
    }
    self.find('#billing_country').on('change', countryNotice)
    countryNotice()
  }

  self.coupon_form_original = $('.woocommerce > .woocommerce-form-coupon')
  self.coupon_field_original = self.coupon_form_original.find('input[name="coupon_code"]')
  self.coupon_form = self.coupon_form_original.clone()
  self.coupon_field = self.coupon_form.find('input[name="coupon_code"]')

  self.block_params = {
    message: null,
    overlayCSS: {
      'background-color': '#ffffff',
    },
  }

  // Tabindex
  self.find('input#createaccount').attr('tabindex', 2)
  self.find('.woocommerce-billing-fields input').attr('tabindex', 3)
  self.find('.woocommerce-billing-fields #billing_postcode').attr('tabindex', 4)
  self.find('.woocommerce-billing-fields select').attr('tabindex', 5)
  self.find('.woocommerce-billing-fields #billing_phone').attr('tabindex', 6)
  self.find('.woocommerce-additional-fields textarea, .woocommerce-billing-fields input[name="ship_to_different_address"]').attr('tabindex', 7)
  self.find('.woocommerce-shipping-fields input').attr('tabindex', 8)
  self.find('.woocommerce-shipping-fields #shipping_postcode').attr('tabindex', 9)
  self.find('.woocommerce-shipping-fields select').attr('tabindex', 10)
  self.find('input[name="billing_email"]').attr('tabindex', 1)

  // Toggle order info on mobile
  $('.js-toggle-cart-mobile').click(function() {
    $(this).toggleClass('--open')
    $('.mlmi-cart__col-right').css('--max-height', $('.mlmi-cart__col-right .mlmi-cart__col-right-wrapper').outerHeight() + 'px')
    $('.mlmi-cart__col-right').toggleClass('--open')
  })

  // Characters max
  $('.woocommerce-additional-fields textarea[name=order_comments]').each(function() {
    $(this).attr('maxlength', 200)
    $(this).Characters()
  })

  /* Shipping */
  self.card_for_pickup = function(selected_id) {
    if (selected_id == undefined || !selected_id) {
      return
    }
    if (selected_id.includes('_dom-') || selected_id.includes('free_shipping2')) {  // poste canada
      $('label[for="card-for-pickup"]').show()
    } else {
      $('label[for="card-for-pickup"]').hide()
      $('input[name="card_for_pickup"]').prop('checked', false).trigger('change')
    }
  }

  self.initialize_shipping = function() {
    var shipping_template = $('.shipping-choices .shipping-choices__item.--template')
    $('.shipping-choices .shipping-choices__item:not(.--template)').remove()
    $('#shipping_method li').each(function() {
      var new_box = shipping_template.clone().removeClass('--template')
      new_box.attr('data-id', $(this).find('input').attr('id'))
      if ($(this).find('input').attr('id') == 'shipping_method_0_free_shipping2') {
        // keep icon-check
      } else if ($(this).find('input').attr('id') == 'shipping_method_0_local_pickup5') {
        new_box.find('.shipping-choices__item__icon').removeClass('icon-check').addClass('icon-pickup')
      } else {
        new_box.find('.shipping-choices__item__icon').removeClass('icon-check').addClass('icon-express')
      }
      if ($(this).find('.delivery-real-title').length && $(this).find('.delivery-real-title').html() != '') {
        new_box.find('.shipping-choices__item__title').html($(this).find('.delivery-real-title').html())
      } else if ($(this).find('.delivery-title').length && $(this).find('.delivery-title').html() != '') {
        new_box.find('.shipping-choices__item__title').html($(this).find('.delivery-title').html())
      }
      new_box.find('.shipping-choices__item__description-1').html($(this).find('.delivery-delay').html())
      new_box.find('.shipping-choices__item__description-2').html($(this).find('.delivery-estimate').html())
      if ($(this).find('.amount').length && $(this).find('.amount').html() != '') {
        new_box.find('.shipping-choices__item__price').html($(this).find('.amount').html())
      } else if ($(this).find('.delivery-title').length && $(this).find('.delivery-title').html() != '') {
        if ($(this).find('.delivery-title').html().includes('gratuit')) {
          new_box.find('.shipping-choices__item__price').html('Gratuit')
        }
      }
      new_box.appendTo('.shipping-choices')
    })
    $('.shipping-choices').attr('data-count', $('#shipping_method li').length)
    var selected = $("input.shipping_method:checked").attr('id')
    $('.shipping-choices .shipping-choices__item[data-id=' + selected + ']').addClass('--selected')
    $('.shipping-choices .shipping-choices__item').click(function () {
      $('.shipping-choices .shipping-choices__item').removeClass('--selected')
      $(this).addClass('--selected')
      var selected_id = $(this).attr('data-id')
      self.card_for_pickup(selected_id)
      $(window).trigger('resize')
      $('#shipping_method input#' + selected_id).prop('checked', 'true').trigger('change')
    })
    self.card_for_pickup(selected)
  }
  self.initialize_shipping()

  self.maybe_update_shipping_summary = function() {
    if ($('.accordion__item.--completed').length > 1) {
      let accordion = $('.js-accordion__item:nth-child(2)'),
      summary = $('.woocommerce-checkout .mlmi-cart__col-left .accordion').CheckoutAccordion().update_shipping_summary(accordion)
      accordion.find('.js-accordion__summary').html(summary)
    }
    $(window).trigger('resize')
  }

  self.initialize_coupon_code = function() {
    self.coupon_form = self.coupon_form_original.clone()
    self.coupon_field = self.coupon_form.find('input[name="coupon_code"]')
    self.coupon_field.val('')
    $('.coupon-code__toggle-link').off('click').on('click', function() {
      if (self.coupon_form.is(':visible')) {
        self.coupon_form.hide()
      } else {
        self.coupon_form.show()
        self.coupon_field.focus()
      }
      $(window).trigger('resize')
      return false
    })
    $('.coupon-code__toggle-link').click().hide()
    $('.place-order .woocommerce-form-coupon').replaceWith(self.coupon_form)
    self.coupon_form.on('submit', function(e) {
      e.preventDefault()
      self.coupon_field_original.val(self.coupon_field.val())
      self.coupon_form_original.submit()
      $(window).trigger('resize')
      return false
    })
    $(window).trigger('resize')
    $(document.body).off('click', 'a.mlmi-remove-coupon').on('click', 'a.mlmi-remove-coupon', $.mlmi.cart.remove_coupon)
  }

  self.block_ui = function() {
    $(window).trigger('resize')
    $('.mlmi-cart').block(self.block_params)
  }

  self.unblock_ui = function() {
    $(window).trigger('resize')
    $('.mlmi-cart').unblock()
  }

  self.errors = function(error) {
    $(window).trigger('resize')
    $.mlmi.cart.errors(error)
  }

  self.update_from_cart = function() {
    self.unblock_ui()
    self.initialize_shipping()
    self.initialize_coupon_code()
    self.maybe_update_shipping_summary()
    self.errors()
  }

  return function() {
    $(document.body).on('updated_checkout', function() {
      self.unblock_ui()
      self.initialize_shipping()
      self.initialize_coupon_code()
      self.maybe_update_shipping_summary()
      self.errors()
    })
    $(document.body).on('stripeError checkout_error', function() {
      self.unblock_ui()
      self.errors()
    })
    $('form.checkout').on('checkout_place_order', self.block_ui)
    self.errors()
    $(window).trigger('resize')
    self.data('checkout-form', self)
    return self
  }()
}
